/* Turnos de guardia: lo que no es pantalla · P13 (29 sep 2026).
   Vive aparte de Guardia.jsx para que la pantalla solo exporte componentes
   y las reglas se prueben sin montar nada. */

// VALORES POR OMISIÓN SENSATOS (Doctrina 2, regla 4 · P13, 29 sep 2026).
// El turno nace de la próxima hora en punto a doce horas después: quien
// programa solo elige a la persona, y las fechas se cambian si hace falta.
// En hora LOCAL, que es lo que pide `datetime-local`.
function aLocal(d) {
  const dos = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}T${dos(d.getHours())}:${dos(d.getMinutes())}`;
}
export function turnoPorOmision(ahora = new Date()) {
  const desde = new Date(ahora);
  desde.setMinutes(0, 0, 0);
  desde.setHours(desde.getHours() + 1);
  const hasta = new Date(desde);
  hasta.setHours(hasta.getHours() + 12);
  return { id_usuario: '', desde: aLocal(desde), hasta: aLocal(hasta) };
}

// Lo que falta para poder programar, en una frase; null si ya se puede.
export function faltaParaTurno(nuevo, tecnicos) {
  if (!nuevo.id_usuario) {
    return tecnicos.length === 0
      ? 'No hay técnicos en la mesa todavía: agrégalos en Configuración de la mesa → Colas y técnicos, y aquí aparecen.'
      : 'Elige quién está de guardia para poder programar el turno.';
  }
  if (!nuevo.desde || !nuevo.hasta) return 'Pon cuándo empieza y cuándo termina el turno.';
  if (new Date(nuevo.hasta) <= new Date(nuevo.desde)) return 'El turno termina antes de empezar: revisa las fechas, primero el inicio y luego el fin.';
  return null;
}
